module.exports = __webpack_public_path__ + "static/img/c1.011c1385.svg";